export const UNINITIALIZED_VALUE = Symbol();
export type UninitializedValue = typeof UNINITIALIZED_VALUE;